export default "__VITE_ASSET__BNFUwSnI__"